<template>
  <div class="facilities w100">
    <div class="page-header">
      <div class="ImageTitle font12" >ARTIST’S IMPRESSION</div>
    </div>
    <div class="bg-575252">
      <div class="w60 m-auto p-top-50" style="padding-bottom: 140px;">
        <h2 class="a98b59-color w80 m-auto lt5 medium p-top-50 font25 m-btm-50">
          IMAGINE YOURSELF HERE
        </h2>
        <p class="Initial regular color-white m-auto m-btm-50 font21 lh35" style="width: 90%;">
          Welcome to EC living on a whole new level. Four pools. Just because. <br>
          And every amenity you could need to make every day feel like a holiday.
        </p>
        <div class="flex-center relative w100 m-btm-20 p-top-20"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        >
          <!-- <img class="img-initial" src="@/assets/home/home-video.png" alt="" /> -->
          <video
            ref="video"
            playsinline
            @play="playType = false"
            @pause="playType = true"
            @ended="playType = true"
            poster="@/assets/facilities/facilities2.png"
            class="img-initial"
            src="@/assets/video/video3.mp4"
          ></video>
          <div v-if="playType || (!playType && mouseType)" class="controls">
            <button @click="rewind">
              <svg t="1730445007352" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5506" width="32" height="32"><path d="M981.333333 223.722667v570.197333c0 47.082667-33.28 66.496-74.346666 43.221333L401.984 550.976c-41.045333-23.253333-41.066667-61.013333 0-84.266667L906.986667 180.501333C948.010667 157.269333 981.333333 176.597333 981.333333 223.722667z m-558.293333 280.106666a41.173333 41.173333 0 0 0-7.232 4.992c1.706667 1.536 4.074667 3.242667 7.210667 5.034667L928.021333 800c12.608 7.146667 10.645333 8.32 10.645334-6.101333V223.722667c0-14.4 1.984-13.226667-10.666667-6.08L423.04 503.808z m195.989333-247.381333l-0.042666-9.045333c-0.106667-30.784-15.893333-39.914667-42.709334-24.725334L106.709333 488.768c-26.602667 15.061333-26.602667 31.957333 0 47.018667l469.546667 266.090666c26.794667 15.168 42.538667 5.973333 42.624-24.874666v-8.682667a21.333333 21.333333 0 1 1 42.666667 0.106667v8.682666c-0.149333 63.466667-51.093333 93.162667-106.304 61.866667L85.674667 572.928c-55.445333-31.402667-55.445333-89.856 0-121.258667l469.546666-266.090666c55.210667-31.274667 106.197333-1.728 106.453334 61.674666v9.045334a21.333333 21.333333 0 1 1-42.666667 0.170666z" fill="#ffffff" p-id="5507"></path></svg>
            </button>
            <button v-if="playType" @click="play">
              <svg t="1730444951954" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4795" width="32" height="32"><path d="M675.328 117.717333A425.429333 425.429333 0 0 0 512 85.333333C276.352 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667 426.666667-191.018667 426.666667-426.666667c0-56.746667-11.093333-112-32.384-163.328a21.333333 21.333333 0 0 0-39.402667 16.341333A382.762667 382.762667 0 0 1 896 512c0 212.074667-171.925333 384-384 384S128 724.074667 128 512 299.925333 128 512 128c51.114667 0 100.8 9.984 146.986667 29.12a21.333333 21.333333 0 0 0 16.341333-39.402667zM456.704 305.92C432.704 289.152 405.333333 303.082667 405.333333 331.797333v360.533334c0 28.586667 27.541333 42.538667 51.370667 25.856l252.352-176.768c21.76-15.253333 21.632-43.541333 0-58.709334l-252.373333-176.768z m-8.597333 366.72V351.466667l229.269333 160.597333-229.269333 160.597333z" fill="#ffffff" p-id="4796"></path></svg>
            </button>
            <button v-else @click="pause">
              <svg t="1730444977832" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5016" width="32" height="32"><path d="M128 106.858667C128 94.976 137.621333 85.333333 149.12 85.333333h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333H149.12A21.290667 21.290667 0 0 1 128 917.141333V106.88z m640 0c0-11.882667 9.621333-21.525333 21.12-21.525334h85.76c11.648 0 21.12 9.6 21.12 21.525334V917.12c0 11.882667-9.621333 21.525333-21.12 21.525333h-85.76a21.290667 21.290667 0 0 1-21.12-21.525333V106.88z" fill="#ffffff" p-id="5017"></path></svg>
            </button>
            <button @click="fastForward">
              <svg t="1730444993588" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5237" width="32" height="32"><path d="M600.96 503.808L96 217.642667c-12.650667-7.168-10.666667-8.32-10.666667 6.08v570.197333c0 14.4-1.962667 13.248 10.666667 6.101333l504.96-286.165333c3.157333-1.792 5.546667-3.498667 7.232-5.034667a41.173333 41.173333 0 0 0-7.210667-5.013333zM42.666667 223.722667c0-47.146667 33.322667-66.453333 74.346666-43.2l505.002667 286.165333c41.066667 23.274667 41.045333 61.013333 0 84.266667L117.013333 837.162667C75.946667 860.416 42.666667 841.002667 42.666667 793.92V223.722667z m362.304 32.725333a21.333333 21.333333 0 1 1-42.666667-0.170667l0.042667-9.045333c0.234667-63.402667 51.221333-92.949333 106.410666-61.653333L938.325333 451.626667c55.445333 31.402667 55.445333 89.856 0 121.258666l-469.546666 266.090667c-55.232 31.274667-106.176 1.578667-106.325334-61.888v-8.682667a21.333333 21.333333 0 1 1 42.666667-0.106666v8.682666c0.085333 30.869333 15.829333 40.042667 42.602667 24.874667l469.568-266.090667c26.602667-15.061333 26.602667-31.957333 0-47.018666l-469.546667-266.090667c-26.837333-15.189333-42.624-6.058667-42.730667 24.725333l-0.042666 9.045334z" fill="#ffffff" p-id="5238"></path></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="a98b59-color relative w100 fs-bg p-top-120">
      <h2 class="Initial lt5 medium font25 p-btm-20 p-top-50">JOY IN EVERY CORNER</h2>
      <p class="Initial font48 p-btm-50 extralight">
        SPACE FOR EVERYONE
      </p>
      <!-- <div class="img-content">
        <img
          style="width: 60%; margin: auto"
          src="@/assets/facilities/_Novo Site Plan 26SEP_RGB_lr.png"
          alt=""
        />
      </div> -->
      <div class="p-btm-50 f-maps">
        <iframe class="w100 h100" src="./siteplan.html" frameborder="0"></iframe>
      </div>
    </div>
    <div class="bg-f7f6f6 a98b59-color relative w100 p-top-200">
      <img
        class="w100 absolute"
        style="left: 0px; top: 0;"
        src="@/assets/btn/line4.png"
        alt=""
      />
      <p class="Initial p-top-50 lt5 medium font25 p-btm-20 p-top-50">RESORT-STYLE LIVING</p>
      <p class="font48 Initial p-btm-50 extralight">
        YOUR DAILY INDULGENCE
      </p>
      <div class="w60 m-auto p-btm-50">
        <!-- swiper -->
        <div
          class="flex-row content-around regular font21 cursor-pointer color-575252"
        >
          <div
            class="flex1 font14 flex-center lt2"
            v-for="(item, index) in facilitiesImgList"
            :key="index"
            :class="{ TabIndex: facilitiesImgIndex == index }"
            @click="setIndex(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="w100 relative">
          <swiper
            class="swiper swiperTop bg-525c4e w100"
            :options="swiperOption"
            ref="swiperOption"
          >
            <swiper-slide
              class="flex-center"
              v-for="(item, i) in nowImgList.imgList"
              :key="i"
            >
              <div class="img-content w100 h100">
                <img :src="item.path" alt="" />
                <p style="right: 0" class="color-white">
                  {{ item.name }}
                </p>
              </div>
            </swiper-slide>
          </swiper>
          <div class="FacSwiperIndex" >
          <div 
          v-for="(item, i) in nowImgList.imgList"
                :class="{ TabIndex: swiperIndexs == i }"
                :key="i"
                style="object-fit: cover;width: 10%;height: 85%;margin: 5px;"
                @click="handleSlideClick(i)"

          >
            <img
                class="h100 w100"
                style="object-fit: cover;"
                ondragstart="return false;"
                :src="item.path"
                alt=""
              />
          </div>

          </div>
          <!-- <swiper
            class="swiper swiperBtm"
            :options="swiperOptionBottom"
            ref="swiperOptionBottom"
          >
            <swiper-slide v-for="(item, i) in nowImgList.imgList" :key="i">
              <img
                class="w100 h100"
                style="object-fit: cover"
                ondragstart="return false;"
                :src="item.path"
                alt=""
                @click="handleSlideClick(i)"
              />
            </swiper-slide>
          </swiper> -->
          <div class="swiper-button-prev" style="left: -15%; top: 45%">
            <img src="@/assets/btn/left2.png" alt="" />
          </div>
          <div class="swiper-button-next" style="right: -15%; top: 45%">
            <img src="@/assets/btn/right2.png" alt="" />
          </div>
        </div>

        <h2 class="a98b59-color medium lt3 p-top-50 font21">
          TIME TOGETHER. TIME FOR YOURSELF.
        </h2>
        <p class="Initial font16 regular color-black p-btm-50 lh35">
          With all the communal spaces within Novo Place, the options are
          extraordinary. There are club rooms and a private dining room to host
          family and friends, activity zones for kids to play in, and even quiet
          spaces for you to read, work or get away from it all.
        </p>
      </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      mouseType:false,
      playType: true,
      showControls: false,
      facilitiesImgIndex: 0,
      nowImgList: [],
      facilitiesImgList: {
        0: {
          name: "ARRIVAL ZONE",
          imgList: [
            {
              name: "ARRIVAL PLAZA | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Arrival Plaza_RGB_lr.jpg"),
            },
            {
              name: "LIBRARY / WORK LOUNGE | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Library_RGB_lr.jpg"),
            },
            
          ],
        },
        1: {
          name: "WELLNESS RETREAT",
          imgList: [
            {
              name: "50M LAP POOL | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_50m Lap Pool_RGB_lr.jpg"),
            },
            {
              name: "GYMNASIUM | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Gym_RGB_lr.jpg"),
            },
            {
              name: "THE DINING ROOM | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Gourmet Dining_RGB_lr.jpg"),
            },
            {
              name: "WELLNESS POOL | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Wellness Pool_RGB_lr.jpg"),
            },
            
          ],
        },
        2: {
          name: "SOCIAL DOMAIN",
          imgList: [
            {
              name: "JACUZZI POOL | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Jacuzzi_RGB_lr.jpg"),
            },
            {
              name: "CLUB ROOM 1 AND 2 | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Clubhouse Night_RGB_lr.jpg"),
            },
            {
              name: "CLUB HOUSE | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Clubhouse w Linear Park_RGB_lr.jpg"),
            },
            
          ],
        },
        3: {
          name: "PLAY ZONE",
          imgList: [
            {
              name: "PLAYGROUND | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Playground_RGB_lr.jpg"),
            },
            {
              name: "KIDS’ PARTY ROOM | ARTIST’S IMPRESSION",
              path: require("@/assets/gallery/_Novo RDR_Kids Party Room_RGB_lr.jpg"),
            },
          ],
        },
      },
      swiperOptionBottom: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 10,
        loopedSlides: 0, // looped slides should be the same
        // loop:true,
        touchRatio: 0.2,
        spaceBetween: 10,
        centeredSlides: true,
        // direction: 'vertical',
      },
      swiperIndexs:0,
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 4, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        on:{
          slideChange: (e)=> {
            console.log(this.$refs.swiperOption.swiper.activeIndex);
            this.swiperIndexs = this.$refs.swiperOption.swiper.activeIndex;
            console.log('======>', this.swiperIndexs);
          },
        },
        // loop:true,
        // autoplay: {
        //     delay: 3000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    handleMouseEnter() {
      this.mouseType = true;
    },
    handleMouseLeave() {
      this.mouseType = false;
    },
    play() {
      this.$refs.video.play();
    },
    pause() {
      this.$refs.video.pause();
    },
    rewind() {
      this.$refs.video.currentTime -= 5; // 倒退5秒
    },
    fastForward() {
      this.$refs.video.currentTime += 5; // 快进5秒
    },
    setIndex(index) {
      console.log(index);
      this.facilitiesImgIndex = index;

      this.nowImgList = this.facilitiesImgList[index];
      this.swiperIndexs = 0;
      this.$refs.swiperOption.swiper.slideTo(0);
    },
    handleSlideClick(index) {
      // 切换到指定索引的 slide
      console.log(index);
      this.swiperIndexs = index;
      this.$refs.swiperOption.swiper.slideTo(index);
    },
  },
  mounted() {
    this.nowImgList = this.facilitiesImgList[0];
    this.$nextTick(() => {
      // if (this.$refs.swiperOption && this.$refs.swiperOption.swiper) {
      //   console.log('Swiper initialized:', this.$refs.swiperOption.swiper);
      // } else {
      //   console.error('Swiper not initialized');
      // }
      // const top = this.$refs.swiperOption.swiper;
      // const bottom = this.$refs.swiperOptionBottom.swiper;
      // top.controller.control = bottom;
      // bottom.controller.control = top;
    });
  },
};
</script>

<style lang="less">
.fs-bg {
  background-image: url("~@/assets/facilities/facilities-bg.png");
  background-size: cover;
}

.facilities {
  margin-top: -56px;
  .page-header {
    height: calc(100vh - 110px);
    background-image: url("~@/assets/gallery/_Novo RDR_Clubhouse w Linear Park_RGB_lr.jpg");
    background-size: cover;
    background-position-y: 50%;
    position: relative;
  }
  .f-maps{
    height: 85vw;
    width: 80%;
    margin: auto;
  }
  .controls{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    button{
      background-color: #faebd700;
      box-shadow: none;
      padding: 0;
      border: 0;
      margin: 0 4vw;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 2rem;
      max-width: 2rem;
    }
  }
  .swiperTop{
    height: 65vh;
  }
  .swiperBtm {
    height: 75px;
    padding-bottom: 15px;
    padding-top: 10px;
  }
  .FacSwiperIndex{
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: stretch;

    width: 100%;
    height: 75px;
    .TabIndex::before{
      margin-bottom: -5px;
    }
  }
  .swiperBtm .swiper-slide {
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
  .swiperBtm .swiper-slide-active {
    position: relative;
    opacity: 1;
  }
  .swiperBtm .swiper-slide-active::before {
    position: absolute;
    left: 0;
    bottom: -8px;
    content: "";
    background-color: #a98b59;
    width: 100%;
    height: 5px;
  }
}

@media (max-width: 900px) {

  .facilities{
    .page-header{
      height: 30vh;
    }
  .f-maps{
    height: 50vh;
    width: 80%;
    margin: auto;
  }

  .swiperTop{
    height: 40vh;
  }
  .swiperBtm {
    height: 25px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .FacSwiperIndex{
    height: 35px;
    .TabIndex{
      height: 35px !important;
    }
    .TabIndex::before{
      margin-bottom: -5px;
    }
  }
  .swiper-button-prev,
  .swiper-button-next{
    display: none;
  }
  }


}


</style>















